var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFranceFlagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "emojione:flag-for-france",
    clipPath: "url(#clip0_834_617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.53418 8.9999C0.53418 12.6843 2.89668 15.8062 6.15918 16.9593V1.04053C2.89668 2.19365 0.53418 5.31553 0.53418 8.9999Z",
    fill: "#002495"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.4092 8.9999C17.4092 5.31553 15.0748 2.19365 11.7842 1.04053V16.9593C15.0748 15.8062 17.4092 12.6843 17.4092 8.9999Z",
    fill: "#ED2939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.15918 16.9594C7.03105 17.2687 7.9873 17.4375 8.97168 17.4375C9.95605 17.4375 10.9123 17.2687 11.7842 16.9594V1.04063C10.9123 0.73125 9.98418 0.5625 8.97168 0.5625C7.95918 0.5625 7.03105 0.73125 6.15918 1.04063V16.9594Z",
    fill: "#EEEEEE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_834_617"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFranceFlagIcon);
export default __webpack_public_path__ + "static/media/france-flag-icon.a6895bd7ba1ae872e9d91b7d91706670.svg";
export { ForwardRef as ReactComponent };